import React from 'react'
import { CellStyle, ExpandableCellStyle, ExpandableLine, LineStyle, P } from '../styles'
import { IconComponent } from '~/assets/icons/component'

interface Column {
  key: string
  width?: string
  minWidth?: string
  onClick?: (cellProp: any) => void
  Component?: (data: any) => JSX.Element
}

interface BodyExpandableLineProps {
  model: Column[]
  lineHeight?: string
  noHover?: boolean
  rowSeparator?: boolean
  item: {
    expandable?: boolean
    onClick?: VoidFunction
    expandableComponent?: JSX.Element
  }
}

export const BodyExpandableLine = ({
  model,
  item,
  lineHeight,
  noHover,
  rowSeparator
}: BodyExpandableLineProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = React.useState(false)

  const handleLineClick = () => {
    if (item?.onClick) {
      item.onClick()
    }
    setIsExpanded(prevState => !prevState)
  }

  return (
    <>
      <LineStyle
        height={lineHeight}
        noHover={noHover}
        separator={rowSeparator}
        onClick={handleLineClick}
        isExpandedLine={isExpanded}
        data-testid={'table-line'}
      >
        {item.expandable && (
          <ExpandableCellStyle data-testid="table-expandable-cell" length={length} width="50px" minWidth="50px">
            {isExpanded ? (
              <IconComponent name="chevronUp" iconsize={10} />
            ) : (
              <IconComponent name="chevronDown" iconsize={10} />
            )}
          </ExpandableCellStyle>
        )}

        {model.map((column: Column, i) => {
          const { key, width, minWidth, Component } = column

          return (
            <CellStyle data-testid="table-cell" key={i} length={model.length} width={width} minWidth={minWidth}>
              {Component ? <Component {...item} /> : <P>{item[key]}</P>}
            </CellStyle>
          )
        })}
      </LineStyle>
      {isExpanded && item.expandable && <ExpandableLine>{item.expandableComponent}</ExpandableLine>}
    </>
  )
}
